import { getToken } from '../libs/axiosApi';

export default function generateUrlWithToken(url) {
  const [, token] = getToken().split(' ');
  return `${url}?token=${token}`;
}
